import React from 'react';
import { useDispatch } from 'react-redux';
import {
  // Button,
  TextField,
  FormControl,
  InputAdornment,
  makeStyles,
} from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import Button from '../../../components/MaterialKit/CustomButtons/Button';
import { setAlert } from '../../../slices/alertSlice';
import { CheckFormikValues } from '../../../components/Formik/CheckFormikValues';
import CardBody from 'components/MaterialKit/Card/CardBody.js';
import CardHeader from 'components/MaterialKit/Card/CardHeader.js';
import styles from 'assets/jss/material-kit-react/views/loginPage.js';
import CardFooter from 'components/MaterialKit/Card/CardFooter';

const useStyles = makeStyles(styles);

const ForgotPasswordForm = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const check = false;
  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
  } = props;

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      <CardHeader color='black' className={classes.cardHeader}>
        <h3>Forgot Password</h3>
      </CardHeader>

      <CardBody>
        <FormControl style={{ padding: '1rem', width: '100%' }}>
          <TextField
            variant='outlined'
            label='Email'
            placeholder='Enter Email Address'
            name='email'
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.email && touched.email}
            helperText={errors.email && touched.email && errors.email}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
      </CardBody>
      <CardFooter>
        <Button
          type='submit'
          fullWidth
          onClick={() => {
            if (!values.email) {
              dispatch(setAlert('Please fill in email properly!', 'warning'));
            }
          }}
          color='danger'
          round
        >
          Submit
        </Button>

        {check ? <CheckFormikValues {...props} /> : ''}
      </CardFooter>
    </form>
  );
};

export { ForgotPasswordForm };
